<template>
  <div :class="type" class="global-loading-mask" v-if="loadingState.visible">
    <div class="global-loading-wrapper">
      <div class="global-loading-spinner"></div>
      <!-- <div class="global-loading-text" v-if="loadingState.text">{{ loadingState.text }}</div> -->
    </div>
  </div>
</template>

<script setup>
import { loadingService } from '@/utils/loadingService'
import { isMobile } from '@/utils'

const type = isMobile ? 'mobile' : 'pc'
// 直接使用loadingService中的状态
const loadingState = loadingService.getState()
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style> 